"use strict";
// Synced with the definitions in DIM/src/app/settings/reducer.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = exports.DtrReviewPlatform = exports.DtrD2ActivityModes = exports.InfuseDirection = void 0;
var InfuseDirection;
(function (InfuseDirection) {
    /** infuse something into the query (query = target) */
    InfuseDirection[InfuseDirection["INFUSE"] = 0] = "INFUSE";
    /** infuse the query into the target (query = source) */
    InfuseDirection[InfuseDirection["FUEL"] = 1] = "FUEL";
})(InfuseDirection = exports.InfuseDirection || (exports.InfuseDirection = {}));
/** The subset of DestinyActivityModeType that we use for game modes. */
var DtrD2ActivityModes;
(function (DtrD2ActivityModes) {
    DtrD2ActivityModes[DtrD2ActivityModes["notSpecified"] = 0] = "notSpecified";
    DtrD2ActivityModes[DtrD2ActivityModes["playerVersusEnemy"] = 7] = "playerVersusEnemy";
    DtrD2ActivityModes[DtrD2ActivityModes["playerVersusPlayer"] = 5] = "playerVersusPlayer";
    DtrD2ActivityModes[DtrD2ActivityModes["raid"] = 4] = "raid";
    // trials = DestinyActivityModeType.TrialsOfTheNine
    DtrD2ActivityModes[DtrD2ActivityModes["gambit"] = 63] = "gambit";
})(DtrD2ActivityModes = exports.DtrD2ActivityModes || (exports.DtrD2ActivityModes = {}));
var DtrReviewPlatform;
(function (DtrReviewPlatform) {
    DtrReviewPlatform[DtrReviewPlatform["All"] = 0] = "All";
    DtrReviewPlatform[DtrReviewPlatform["Xbox"] = 1] = "Xbox";
    DtrReviewPlatform[DtrReviewPlatform["Playstation"] = 2] = "Playstation";
    DtrReviewPlatform[DtrReviewPlatform["AllConsoles"] = 101] = "AllConsoles";
    DtrReviewPlatform[DtrReviewPlatform["Pc"] = 3] = "Pc";
})(DtrReviewPlatform = exports.DtrReviewPlatform || (exports.DtrReviewPlatform = {}));
exports.defaultSettings = {
    // Show full details in item popup
    itemDetails: true,
    // Show item quality percentages
    itemQuality: true,
    // Show new items with a red dot
    showNewItems: false,
    // Show item reviews
    showReviews: true,
    // Can we post identifying information to DTR?
    allowIdPostToDtr: true,
    // Sort characters (mostRecent, mostRecentReverse, fixed)
    characterOrder: 'mostRecent',
    // Sort items in buckets (primaryStat, rarityThenPrimary, quality)
    itemSort: 'custom',
    itemSortOrderCustom: ['primStat', 'name'],
    // How many columns to display character buckets
    charCol: 3,
    // How many columns to display character buckets on Mobile
    charColMobile: 4,
    // How big in pixels to draw items - start smaller for iPad
    itemSize: 50,
    // Which categories or buckets should be collapsed?
    collapsedSections: {},
    // Hide triumphs once they're completed
    completedRecordsHidden: false,
    // Hide show triumphs the manifest recommends be redacted
    redactedRecordsRevealed: false,
    // Whether to keep one slot per item type open
    farmingMakeRoomForItems: true,
    // Destiny 2 platform selection for ratings + reviews
    reviewsPlatformSelectionV2: 0,
    // Destiny 2 play mode selection for ratings + reviews - see DestinyActivityModeType for values
    reviewsModeSelection: DtrD2ActivityModes.notSpecified,
    hideCompletedRecords: false,
    customCharacterSort: [],
    infusionDirection: InfuseDirection.INFUSE,
    itemPickerEquip: true,
    language: 'en',
    colorA11y: '-',
    wishListSource: 'https://raw.githubusercontent.com/48klocs/dim-wish-list-sources/master/voltron.txt',
    loStatSortOrder: [
        2996146975,
        392767087,
        1943323491,
        1735777505,
        144602215,
        4244567218,
    ],
    loAssumeMasterwork: false,
    loMinPower: 750,
    loMinStatTotal: 55,
    customTotalStatsByClass: {},
    organizerColumnsWeapons: [
        'icon',
        'name',
        'dmg',
        'power',
        'locked',
        'tag',
        'wishList',
        'archetype',
        'perks',
        'notes',
    ],
    organizerColumnsArmor: [
        'icon',
        'name',
        'power',
        'dmg',
        'energy',
        'locked',
        'tag',
        'ghost',
        'modslot',
        'perks',
        'stats',
        'customstat',
        'notes',
    ],
    organizerColumnsGhost: ['icon', 'name', 'locked', 'tag', 'perks', 'notes'],
    compareBaseStats: false,
    sidecarCollapsed: false,
    singleCharacter: false,
};
